"use client";

import { useEffect, useState, useCallback } from "react";
import { DataTable } from "@/components/table/dataTable";
import { DataTableNavBar } from "@/components/table/dataTableNavbar";
import { DataTableTabs } from "@/components/table/dataTableTabs";
import { getCookies, setCookie } from "cookies-next/client";

export function ItemsDataTable({ pageSize, initialData, columns, initialFavorites, initialPinned }) {
    const [data, setData] = useState(initialData);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [lastRefreshTime, setLastRefreshTime] = useState(Date.now());
    const autoRefreshDuration = (process.env.NODE_ENV === "development" ? 900 : 30) * 1000;

    const [globalFilter, setGlobalFilter] = useState("");

    const refreshData = useCallback(async () => {
        setLastRefreshTime(Date.now());
        setIsRefreshing(true);

        try {
            const response = await fetch(`/api/osrs/updateItems`);

            const res = await response.json();
            setData(res.items);
        } catch (err) {
            console.error("Error refreshing data:", err);
        } finally {
            setIsRefreshing(false);
        }
    }, []);

    const loadAllItems = useCallback(async () => {
        try {
            const response = await fetch(`/api/osrs/items?geOnly=true`);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const res = await response.json();
            setData(res.items);
        } catch (err) {
            console.error("Error loading more items:", err);
        }
    });

    const [favorites, _setFavorites] = useState(initialFavorites);
    const [pinned, _setPinned] = useState(initialPinned); // map where key = row id, value = item id
    const setFavorites = (newFavorites) => {
        _setFavorites(new Set(newFavorites));
    };
    const setPinned = (newPinned) => {
        _setPinned(new Map(newPinned));
    };

    useEffect(() => {
        setCookie("osrs_favorites", JSON.stringify(Array.from(favorites)));
        setCookie("osrs_pinned", JSON.stringify(Array.from(pinned.entries())));
    }, [favorites, pinned]);

    return (
        <div className="mx-4 lg:mx-48 mt-4 mb-0 flex flex-col gap-4">
            <DataTableNavBar
                onRefresh={refreshData}
                isRefreshing={isRefreshing}
                globalFilter={globalFilter}
                onFilterChange={(val) => setGlobalFilter(val)}
                lastRefreshTime={lastRefreshTime}
                autoRefreshDuration={autoRefreshDuration}
            />
            <DataTable
                pageSize={pageSize}
                columns={columns}
                data={data}
                setData={setData}
                loadAllItems={loadAllItems}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                favorites={favorites}
                setFavorites={setFavorites}
                pinned={pinned}
                setPinned={setPinned}
            />
        </div>
    );
}
